import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_sy",
  "use": "icon-ic_sy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_sy\">\r\n<path d=\"M17.625 6.375V17.625H15.375V6.375H17.625ZM8.625 6.375V17.625H6.375V6.375H8.625ZM4.125 9.75V14.25H1.875V9.75H4.125ZM22.125 9.75V14.25H19.875V9.75H22.125ZM13.125 3V21H10.875V3H13.125Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol